import React from 'react';
import { ClockIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Countdown } from '../Countdown';
import { PriceCard } from '../PriceCard';
import { paymentMethods } from '../../data/landing';
const assurances = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}];
export function FinalCta() {
  return <section className="bg-brand-soft px-5 py-16 md:py-24" data-id="element-107" data-mp="1en086bswfi2p">
      <div className="mx-auto max-w-3xl text-center" data-id="element-108" data-mp="1iqy4yfur4gsl">
        <p className="flex items-center justify-center gap-2 text-sm font-black uppercase tracking-[0.15em] text-danger md:text-base" data-id="element-109" data-mp="1ink3raxtqdmq">
          <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-110" data-mp="19of4u3icoia1" />
          El precio cierra en:
        </p>
        <div className="mt-6" data-id="element-111" data-mp="2z3v9b5lbxftl">
          <Countdown data-id="element-112" data-mp="2z4y1rhyavqbm" />
        </div>

        <div className="mt-12 flex flex-col gap-10" data-id="element-113" data-mp="34380u3n5bb2i">
          <PriceCard subtitle="5 Tomos + 5 Bonos " idealFor="Quienes quieren curación de 7 a 15 días " ctaLabel="Quiero el MegaPack ahora" originalPrice="$108.000" currentPrice="$53.990" data-id="element-114" data-mp="342puge6rrggv" />
          <PriceCard subtitle="5 Tomos + 5 Bonos + Plan Maestro · Todos los días (7 → 30 días)" ctaLabel="Quiero mi MegaPack + Maestro" currentPrice="$127.990" originalPrice="$145.000" title="MegaPack + Plan Maestro de 30 Días" badge="La opción más completa" data-id="element-115" data-mp="3temu95er8z3h" />
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-semibold text-charcoal" data-id="element-116" data-mp="3fev7af69g8dc">
          {assurances.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2" data-id="element-117" data-mp="3og3751ofdh9j">
              <Icon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-118" data-mp="3oe8hxb64f2zn" />
              {label}
            </li>)}
        </ul>
        <p className="mt-4 flex items-center justify-center gap-2 text-sm text-muted" data-id="element-119" data-mp="13q3y0ovn925c">
          <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-120" data-mp="13rxa4jp10ekq" />
          {paymentMethods}
        </p>
      </div>
    </section>;
}